export default uri => {
  const index = uri.indexOf('#');
  return uri.substring(index + 1);
};
